export default __webpack_public_path__ + "static/media/supplier_en.722d2497.svg";